import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfileModelPageRoutingModule } from './profile-model-routing.module';

import { ProfileModelPage } from './profile-model.page';
import { AppNativeHeaderComponent } from '../forms/headerSection/app-native-header/app-native-header.component';
import { SharedModule } from '../shared/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProfileModelPageRoutingModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [ProfileModelPage],
})
export class ProfileModelPageModule {}
